import { atomFamily } from "recoil";

export const datatableAtomFamily = atomFamily({
	key: "datatableAtomFamily",
	default: false,
});
